import { Box, BoxProps, Checkbox } from '@chakra-ui/react'

export interface OfferCellWrapperProps extends BoxProps {
  hasAddAllCheckbox?: boolean
  onCheck?: (checked: boolean) => void
}

export const OfferCellWrapper = ({
  children,
  sx,
  hasAddAllCheckbox,
  onCheck,
  ...rest
}: OfferCellWrapperProps) => {
  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked

    onCheck && onCheck(checked)
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        //justifyContent: 'start',
        gap: 1,
        px: 2,
        py: 2,
        lineHeight: '20px',
        ...sx,
      }}
      {...rest}
    >
      {hasAddAllCheckbox && (
        <Checkbox size="sm" title="Vybrat vše" sx={{ w: 5 }} onChange={handleCheck} />
      )}

      {children}
    </Box>
  )
}
